import { getLocale } from "../runtime";

const da_emptycarttext = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Din indkøbskurv er tom.`
};

const en_emptycarttext = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Your cart is empty.`
};

const es_emptycarttext = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tu carrito está vacío.`
};

const fi_emptycarttext = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ostoskorisi on tyhjä.`
};

const nb_emptycarttext = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Din handlekurv er tom.`
};

const sv_emptycarttext = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Din varukorg är tom.`
};

const emptycarttext = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_emptycarttext(inputs)
	if (locale === "en") return en_emptycarttext(inputs)
	if (locale === "es") return es_emptycarttext(inputs)
	if (locale === "fi") return fi_emptycarttext(inputs)
	if (locale === "nb") return nb_emptycarttext(inputs)
	if (locale === "sv") return sv_emptycarttext(inputs)
	return "emptyCartText";
};

export { emptycarttext as "emptyCartText" };